import withStyles from "react-jss";
import HalfAndHalf from "./halfAndHalf";
import Styles from "./halfAndHalf.styles";

export default withStyles(Styles)(HalfAndHalf);
export { HalfAndHalf };
